import type { PermissionKey } from '../api/schemas';
import { minPlanFor } from '@dale/plans';

import { meetsPlan, type PlanTier } from './plan';

/**
 * Whether the top bar offers "Buscar clientes": only to somebody who may open Clientes (an accountant may not),
 * never to a coach (who meets their clients in the class roster), and only on a plan that has the client list.
 */
export function canSearchClients(input: { coach: boolean; plan: PlanTier | undefined; can: (key: PermissionKey) => boolean }): boolean {
  return !input.coach && meetsPlan(input.plan, minPlanFor('clientes')) && input.can('clientes');
}
